<template>
	<div v-if="!item.hidden" class="menu-wrapper">
		<template v-if="
        hasOneShowingChild(item.children, item) &&
        (!onlyOneChild.children || onlyOneChild.noShowingChildren) &&
        !item.alwaysShow
      ">
			<AppLink v-if="onlyOneChild.meta" :to="resolvePath(onlyOneChild.path)">
				<el-menu-item :index="resolvePath(onlyOneChild.path)" :class="{ 'submenu-title-noDropdown': !isNest }">
					<!-- <i :class="onlyOneChild.meta.icon"></i> -->
					<Item :title="onlyOneChild.meta.title" />
				</el-menu-item>
			</AppLink>
		</template>
		<el-submenu v-else ref="subMenu" :index="resolvePath(item.path)" popper-append-to-body>
			<template slot="title">
				<Item v-if="item.meta" :title="item.meta.title" />
			</template>
			<sidebar-item v-for="child in item.children" :key="child.path" :is-nest="true" :item="child"
				:base-path="resolvePath(child.path)" class="nest-menu" />
		</el-submenu>
	</div>
</template>

<script>
	import path from 'path-browserify'
	import {
		isExternal
	} from "@/utils/validate";
	import Item from "./Item";
	import AppLink from "./Link";
	import FixiOSBug from "./FixiOSBug";

	export default {
		name: "SidebarItem",
		components: {
			Item,
			AppLink,
		},
		mixins: [FixiOSBug],
		props: {
			// route object
			item: {
				type: Object,
				required: true,
			},
			isNest: {
				type: Boolean,
				default: false,
			},
			basePath: {
				type: String,
				default: "",
			},
		},
		data() {
			// To fix https://github.com/PanJiaChen/vue-admin-template/issues/237
			// TODO: refactor with render function
			this.onlyOneChild = null;
			return {};
		},
		mounted() {
			// console.log(item)
		},
		methods: {
			hasOneShowingChild(children = [], parent) {
				const showingChildren = children.filter((item) => {
					if (item.hidden) {
						return false;
					} else {
						// Temp set(will be used if only has one showing child)
						this.onlyOneChild = item;
						return true;
					}
				});

				// When there is only one child router, the child router is displayed by default
				if (showingChildren.length === 1) {
					return true;
				}

				// Show parent if there are no child router to display
				if (showingChildren.length === 0) {
					this.onlyOneChild = {
						...parent,
						path: "",
						noShowingChildren: true,
					};
					return true;
				}

				return false;
			},
			resolvePath(routePath) {
				if (isExternal(routePath)) {
					return routePath;
				}
				if (isExternal(this.basePath)) {
					return this.basePath;
				}
				return path.resolve(this.basePath, routePath);
			},
		},
	};
</script>
<style lang="less">
@media (max-width:500px){
	.el-menu-item{
		width: 70px !important;
		text-align: center !important;
		letter-spacing: 1px !important;
	}
	
	.el-submenu{
		width: 70px !important;

	}
	.el-submenu__title{
		padding:0px !important; 
	}
	.el-submenu .el-menu-item{
		width: 70px !important;
	}
	.el-menu-item.submenu-title-noDropdown{
		margin-left:5px !important;
	}
}
	.el-menu-item {
		width: 130px;
		text-align: center;
		height: 30px !important;
		line-height: 30px !important;
		float: left;
		box-sizing: border-box;
		border-radius: 5px;
		background-color: rgba(0, 0, 0, 0) !important;
	}
	.el-menu-item *{
		vertical-align: inherit !important;
	}
	.el-menu-item:hover {
		background-color: #0061AE !important;
		color: #fff !important;
	}

	.el-submenu__title:hover {
		background-color: #0061AE !important;
		color: #fff !important;
	}

	.el-submenu {
		width: 130px;
		float: left;
		text-align: center;
		height: 30px !important;
		line-height: 30px !important;
		border-radius: 5px;
		margin-left: 18px !important;
	}

	.el-menu-item.submenu-title-noDropdown {
		margin-left: 18px !important;
		// margin-top: 4px !important;
	}

	.el-submenu .el-menu-item {
		min-width: 130px;
	}

	.el-menu .is-active {
		background-color: #0061AE !important;
		color: #fff !important;
		// background-color: rgba(0, 0, 0, 0);
		// // background: url("../../../../assets/image/menubg.png") no-repeat;
		// background-size: 100% 100%;
	}

	.el-submenu__title {
		height: 30px !important;
		line-height: 30px !important;
		border-radius: 5px;
	}
	.el-submenu.is-active .el-submenu__title{
		background-color: #0061AE !important;
		color: #fff !important;
	}
	.el-submenu__title i {
		color: rgba(0, 0, 0, 0) !important;
	}

	.el-menu--collapse .el-menu .el-submenu,
	.el-menu--popup {
		min-width: 130px !important;
		background-color: #fff !important;
	}

	.el-menu--popup .el-menu-item {
		border-radius: 0px;
		color: #064FBD !important;
	}

	.el-menu--popup .el-menu-item:hover {
		color: #064FBD !important;
	}

	.el-menu--popup-bottom-start .is-active {
		background-color: #0061AE !important;
		color: #fff !important;
	}

	.el-menu--popup .el-menu-item {
		margin: 2px 5px;
		box-sizing: border-box;
	}

	.el-menu--popup-bottom-start .is-active {
		background-color: #AAEDFC !important;
		box-sizing: border-box !important;
	}

	.el-menu--popup .el-menu-item:hover {
		background-color: #AAEDFC !important;
		box-sizing: border-box !important;
	}
</style>